import { appMenuCID } from '../../../components/AppMenu';
import { loadingParagraphCID } from '../../../components/Loading';
import { BreakPoints, LibroTheme, MaterialStyleMap } from '../../types';

export default (theme: LibroTheme): MaterialStyleMap => ({
  MuiListItem: {
    styleOverrides: {
      root: {
        lineHeight: undefined,
        minHeight: undefined,
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: '30px',
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        [theme.breakpoints.down(BreakPoints.Medium)]: {
          [`&.${appMenuCID}`]: {
            maxWidth: '100%',
            width: '100%',
          },
        },
        [`& .${loadingParagraphCID}`]: {
          minWidth: '14em',
        },
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        lineHeight: undefined,
        minHeight: undefined,
        whiteSpace: undefined,
      },
    },
  },
});
